import { Card, CardContent } from '@/components/ui/card';

const BillingClarificationBanner = () => {
  return (
    <Card className="max-w-4xl mx-auto mb-16 bg-gradient-to-br from-primary/5 to-accent/5 border-primary/10">
      <CardContent className="pt-8 pb-8 px-8">
        <h3 className="text-xl font-bold text-foreground mb-6 text-center">
          How Billing Works
        </h3>
        <div className="grid md:grid-cols-3 gap-6 text-center">
          <div className="space-y-2">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center mx-auto mb-2">
              <span className="text-primary font-bold">1</span>
            </div>
            <p className="text-sm font-medium text-foreground">Family members explore for free</p>
            <p className="text-muted-foreground">No time limit, no credit card needed</p>
          </div>
          <div className="space-y-2">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center mx-auto mb-2">
              <span className="text-primary font-bold">2</span>
            </div>
            <p className="text-sm font-medium text-foreground">Billing starts at activation</p>
            <p className="text-muted-foreground">Only when the older adult joins</p>
          </div>
          <div className="space-y-2">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center mx-auto mb-2">
              <span className="text-primary font-bold">3</span>
            </div>
            <p className="text-sm font-medium text-foreground">You get notified first</p>
            <p className="text-muted-foreground">Alert before any charges begin</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default BillingClarificationBanner;
